<template>
    <div class="q-pa-md">
        <div class="row q-col-gutter-lg q-mb-xl">
            <div
                v-for="achievement in achievements[0].courses"
                :key="achievement.id"
                class="col-12 col-sm-6 col-lg-4"
            >
                <q-card class="my-card">
                    <p style="font-size: 22px">
                        <strong>{{ achievement.label }}</strong>
                    </p>
                    <q-card-section>
                        <q-knob
                            v-model="achievement.value"
                            :min="achievement.min"
                            :max="achievement.max"
                            readonly
                            show-value
                            size="90px"
                            :thickness="0.22"
                            :color="achievement.color"
                            :track-color="achievement.trackerColor"
                            class="q-ma-md"
                        />
                    </q-card-section>
                </q-card>
            </div>
        </div>

        <div class="row q-col-gutter-lg q-mb-xl">
            <div class="col-12 col-sm-6 col-md-12 col-lg-6">
                <q-img
                    src="/assets/images/horas_de_estudo.png"
                    spinner-color="white"
                    :ratio="16 / 9"
                />
            </div>
            <div class="col-12 col-sm-6 col-md-12 col-lg-6">
                <q-img
                    src="/assets/images/cursos_comprados.png"
                    spinner-color="white"
                    :ratio="16 / 9"
                />
            </div>
        </div>

        <div class="row q-col-gutter-lg q-mb-xl justify-between">
            <div class="col-6 col-sm-4">
                <q-card class="my-card">
                    <q-img
                        src="/assets/images/medalha.png"
                        spinner-color="white"
                        :ratio="1"
                    />
                    <q-card-section>
                        <div class="text-h5">
                            <strong>300</strong>
                            <br />
                        </div>
                        Horas de estudo completas
                    </q-card-section>
                </q-card>
            </div>
            <div class="col-6 col-sm-4">
                <q-card class="my-card">
                    <q-img
                        src="/assets/images/medalha.png"
                        spinner-color="white"
                        :ratio="1"
                    />
                    <q-card-section>
                        <div class="text-h5">
                            <strong>2</strong>
                            <br />
                        </div>
                        Semanas consecutivas a estudar
                    </q-card-section>
                </q-card>
            </div>
            <div class="col-6 col-sm-4">
                <q-card class="my-card">
                    <q-img
                        src="/assets/images/medalha.png"
                        spinner-color="white"
                        :ratio="1"
                    />
                    <q-card-section>
                        <div class="text-h5">
                            <strong>4</strong>
                            <br />
                        </div>
                        Anos a estudar
                    </q-card-section>
                </q-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Achievements',

    components: {},

    data () {
        return {
            achievements: [
                {
                    courses: [
                        {
                            id: 2,
                            label: 'Cursos Completados',
                            value: 2,
                            min: 0,
                            max: 9,
                            color: 'primary',
                            trackerColor: 'yellow-3',
                        },
                        {
                            id: 3,
                            label: 'Cursos em Progresso',
                            value: 5,
                            min: 0,
                            max: 9,
                            color: 'green-10',
                            trackerColor: 'green-3',
                        },
                        {
                            id: 4,
                            label: 'Cursos por Iniciar',
                            value: 2,
                            min: 0,
                            max: 9,
                            color: 'secondary',
                            trackerColor: 'red-3',
                        },
                    ],
                },
            ],
        }
    },

    methods: {
        progressLabel (value) {
            return (value * 100).toFixed(2) + '%'
        },
    },
}
</script>
